import { render, staticRenderFns } from "./SampleBadgesV3Page.vue?vue&type=template&id=367a1698"
import script from "./SampleBadgesV3Page.vue?vue&type=script&lang=js"
export * from "./SampleBadgesV3Page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports